import { Box, Grid } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { AutorizacaoEspecialContext } from "../../../../context/AutorizacaoEspecialContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import Controls from "../../../../components/controls/Controls";
import { EstabelecimentoOptions } from "../../../../data/Estabelecimentos"
import { RegiaoOptions } from "../../../../data/Regiao"
import { OrgaoEmissorOptions } from "../../../../data/OrgaoEmissor";
import { InputType } from "../../../../components/controls/Input";
import AcademicService from "../../../../services/AcademicService";
import { InputPhoneType } from "../../../../components/controls/PhoneInput";

/* eslint-disable no-useless-escape */
export default function PersonalAddressDataStep() {

    const { state, dispatch } = useContext(AutorizacaoEspecialContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    const [specialtyStateOptions, setSpecialtyStateOptions] = useState([])

    useEffect(() => {
        AcademicService.getAllSpecialtyOptions().then(e => setSpecialtyStateOptions(e))
    }, []);


    return (

        <div>

            <Steps.StepTitle text="Dados Pessoais" />

            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Controls.RadioGroup
                        name="Region"
                        label="Região"
                        value={state.PersonalDataForm.Region.Value}
                        onChange={(e) => {
                            onInputChange("Region", state.PersonalDataForm, e.target.value);
                        }}
                        items={RegiaoOptions}
                        error={state.PersonalDataForm.Region.Error}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>

                    <Controls.RadioGroup
                        name="Establishment"
                        label="Estabelecimento"
                        value={state.PersonalDataForm.Establishment.Value}
                        onChange={(e) => {
                           
                            onInputChange("Establishment", state.PersonalDataForm, e.target.value);
                        }}
                        items={EstabelecimentoOptions}
                        error={state.PersonalDataForm.Establishment.Error}
                    />
                </Grid>

            </Grid>

            <Box mt={2}>

                <Grid container spacing={5}>
                    <Grid item xs={12} sm={12}>
                        <Controls.Input
                            name="Name"
                            label="Nome completo *"
                            maxLength={60}
                            placeholder="Digite o seu nome completo"
                            value={state.PersonalDataForm.Name.Value}
                            onChange={(e) => {
                                e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                                onInputChange("Name", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("Name", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.Name.Error}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <Controls.Input
                            name="CRM"
                            label="Número do Conselho *"
                            maxLength={20}
                            placeholder="Digite o seu número do conselho"
                            value={state.PersonalDataForm.CRM.Value}
                            onChange={(e) => {
                                e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\=?;:'",¨<>\{\}\[\]\\\/]/gi, '');
                                onInputChange("CRM", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("CRM", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.CRM.Error}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <Controls.Autocomplete
                            label="Especialidade *"
                            name="Expertise"
                            placeholder="Selecione"
                            options={specialtyStateOptions}
                            value={state.PersonalDataForm.Expertise.Value}
                            onChange={(e) => {
                                onInputChange("Expertise", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("Expertise", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.Expertise.Error}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <Controls.Input
                            name="CPF"
                            label="CPF *"
                            type={InputType.CPF}
                            placeholder={"___.___.___-__"}
                            value={state.PersonalDataForm.CPF.Value}
                            onChange={(e) => {
                                onInputChange("CPF", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("CPF", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.CPF.Error}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <Controls.DatePicker
                            name="BirthDate"
                            maxDate={new Date()}
                            label="Data de Nascimento *"
                            value={state.PersonalDataForm.BirthDate.Value}
                            onChange={(e) => {
                                onInputChange("BirthDate", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("BirthDate", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.BirthDate.Error}
                        />
                    </Grid>



                    <Grid item xs={6} sm={6}>
                        <Controls.Input
                            name="RG"
                            label="RG *"
                            maxLength={15}
                            placeholder={"Digite o Número do RG"}
                            value={state.PersonalDataForm.RG.Value}
                            onChange={(e) => {
                                ///[&\/\\#,+()$~%[ç¨¨!@"]"_'":*?<>{}]/g
                                e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\=?;:'",¨<>\{\}\[\]\\\/]/gi, '');
                                onInputChange("RG", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("RG", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.RG.Error}
                        />
                    </Grid>


                    <Grid item xs={6} sm={6}>
                        <Controls.Autocomplete
                            label="Orgão Emissor *"
                            name="OM"
                            placeholder="Digite o órgão emissor"
                            options={OrgaoEmissorOptions}
                            value={state.PersonalDataForm.OM.Value}
                            onChange={(e) => {
                                onInputChange("OM", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("OM", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.OM.Error}
                        />
                    </Grid>



                    <Grid item xs={6} sm={6}>
                        <Controls.MuiPhoneInput
                            name="BusinessPhone"
                            label="Telefone Comercial"
                            type={InputPhoneType.TELEFONE}
                            value={state.PersonalDataForm.BusinessPhone.Value}
                            onChange={(e) => {
                                onInputChange("BusinessPhone", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("BusinessPhone", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.BusinessPhone.Error}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>

                        <Controls.MuiPhoneInput
                            name="CellPhone"
                            label="Celular *"
                            type={InputPhoneType.CELULAR}
                            value={state.PersonalDataForm.CellPhone.Value}
                            onChange={(e) => {
                                onInputChange("CellPhone", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("CellPhone", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.CellPhone.Error}
                        />

                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <Controls.Input
                            name="Email"
                            label="E-mail *"
                            maxLength={120}
                            placeholder={"Digite seu e-mail"}
                            value={state.PersonalDataForm.Email.Value}
                            onChange={(e) => {
                                onInputChange("Email", state.PersonalDataForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                onInputChange("Email", state.PersonalDataForm, e.target.value);
                            }}
                            error={state.PersonalDataForm.Email.Error}
                        />
                    </Grid>
                </Grid>
            </Box>

        </div >

    )
}